<template>
  <div style="display: inline-block;">
    <CombinedInput v-if="selectedUser">
      <Input v-if="quantityPicker" type="number" v-model="quantity" min="1" :max="parseInt(quantityMax)" :size="2" small-padding center style="width: 80px;" />
      <FormGroup>
        <Button type="button" fill success @click="handleClick" :loading="loading" :disabled="disabled" icon="plus">{{ $t(data.additionalServiceListing ? 'Registreren' : quantityPicker ? 'Toevoegen' : 'Toevoegen aan winkelmandje') }}</Button>
      </FormGroup>
    </CombinedInput>
    <UserSelect v-else-if="user">{{ $t('Kies een gebruiker') }}</UserSelect>
    <Button primary v-else type="button" fill @click="$router.push({ name: 'Login', query: { redirect: $route.fullPath } })" :disabled="disabled">{{ $t('Inloggen') }}</Button>
    <Modal :timeout="noRedirect ? '1500' : ''" :title="$t('Toegevoegd aan winkelmandje')" ref="modal">
      <p v-if="!noRedirect">{{ $t('Succesvol toegevoegd aan het winkelmandje, afrekenen of verder winkelen?') }}</p>
      <Button v-if="!noRedirect" style="margin-bottom: 0.5rem;" primary @click="goToOverview" :disabled="loading">{{ $t('Verder winkelen') }}</Button> <Button v-if="!noRedirect" success fill @click="goToCart" :disabled="loading">{{ $t('Afrekenen') }}</Button>
    </Modal>
  </div>
</template>

<script>
import Button from '../Core/Button'
import Modal from '../Core/Modal'
import UserSelect from '../Core/UserSelect'
import Input from '../Core/Input'
import CombinedInput from '../Core/CombinedInput'
import FormGroup from '../Core/FormGroup'
export default {
  name: 'AddToCart',
  components: {
    FormGroup,
    CombinedInput,
    Input,
    UserSelect,
    Modal,
    Button
  },
  props: {
    disabled: Boolean,
    data: Object,
    v: Object,
    validate: Function,
    quantityPicker: Boolean,
    quantityMax: [Number, Boolean, String],
    noRedirect: {
      type: Boolean,
      default: false
    },
    webshop: Boolean,
    category: String
  },
  data () {
    return {
      loading: false,
      quantity: 1
    }
  },
  mounted () {
    if (this.data.product || this.data.variant) this.syncVariantStockWithItemsInCart()
  },
  computed: {
    user () {
      return this.$store.getters['user/user']
    },
    selectedUser () {
      return this.$store.getters['user/selectedUser']
    },
    productVariantsInCart () {
      return this.$store.getters['cart/productVariantsData']
    },
    club () {
      return this.$store.getters['club/club']
    }
  },
  methods: {
    async handleClick () {
      if (this.v) {
        this.v.$touch()
        if (this.v.$error) {
          this.$emit('error', this.v)
          return
        }
      }
      if (typeof this.validate === 'function') if (!this.validate()) return
      if (!this.noRedirect) this.$refs.modal.show()
      this.loading = true
      this.data.quantity = this.quantity
      if (this.data.variant) this.data.variant.stock = parseInt(this.data.variant.stock) - parseInt(this.quantity)
      await this.$store.dispatch('cart/addItem', this.data)
      this.$emit('itemAdded')
      if (this.noRedirect) {
        this.$store.commit('notice/addNotices', [
          {
            title: this.$t('toegevoegd aan het winkelmandje'),
            message: this.$t('Succesvol toegevoegd aan het winkelmandje.'),
            type: 'success'
          }
        ])
      } 
      this.loading = false
    },
    goToCart () {
      this.$router.push({ name: 'Cart' })
    },
    goToOverview () {
      if (this.webshop && this.category) this.$router.push({ name: 'WebshopCategory', params: { category: this.category } })
      else if (this.webshop) this.$refs.modal.hide()
      else this.$router.push({ name: 'Club', params: { club: this.club.url } })
    },
    returnToCart () {
      this.$parent.$parent.$parent.$parent.closeManually()
    },
    syncVariantStockWithItemsInCart () {
      if (!Object.keys(this.productVariantsInCart).length) return false
      if (Object.prototype.hasOwnProperty.call(this.productVariantsInCart, this.data.variant.nid)) {
        this.data.variant.stock = parseInt(this.data.variant.stock) - parseInt(this.productVariantsInCart[this.data.variant.nid].qty)
      }
    }
  }
}
</script>
